<template>
  <div>

    <b-modal ref="myModalRef" hide-footer centered>

      <div centered slot="modal-title">
        {{$t('edit.activeSIP')}}
      </div>

      <div class="d-block text-center">

        <div v-if="activeSIPError" class="alert alert-danger">{{$t('anErrorOccurred')}}</div>

        {{$t('edit.areYouSureActive')}}
        <b>{{ sipName }}</b>
      </div>

      <b-button-group size="lg" class="mt25">
        <b-button size="lg" class="custom-bgr-danger" variant="danger" @click="hideModalActiveSIP()">{{$t('edit.cancel')}}</b-button>
        <b-button size="lg" class="custom-bgr-primary" variant="primary" @click="activeSip()">{{$t('edit.active')}}</b-button>
    </b-button-group>

    </b-modal>

    <!--<base-header></base-header>-->
    <div class="container">
      <form>
        <div class="form-header">{{$t('edit.header')}}</div>

        <div class="alert alert-success" v-if="updateProfile == 'ok'">{{$t('alert.update.profile.success')}}</div>
        <div class="alert alert-danger" v-if="updateProfile == 'fail'">{{$t('alert.update.profile.error')}}</div>

        <ul class="list-sip">
          <li class="active">
            <router-link class="url" :to="{name:'EditProfile'}">
              {{name}}
              <font-awesome-icon :icon="fileIco"></font-awesome-icon>
            </router-link>
          </li>
        </ul>
        <div class="clearfix"></div>
      </form>

      <div class="clearfix"></div>

      <div class="form-header box-list-sip">{{$t('edit.sipHeader')}}</div>
      <p class="sipListNote" v-html="$t('edit.sipListNote')"></p>
      <div class="alert alert-success" v-if="sipCreate == 'ok'">{{$t('alert.create.sip.success')}}</div>
      <div class="alert alert-danger" v-if="sipCreate == 'fail'">{{$t('alert.create.sip.error')}}</div>
      <div class="alert alert-success" v-if="sipUpdate == 'ok'">{{$t('alert.update.sip.success')}}</div>
      <div class="alert alert-danger" v-if="sipUpdate == 'fail'">{{$t('alert.update.sip.error')}}</div>
      <div class="alert alert-success" v-if="sipDelete == 'ok'">{{$t('alert.delete.sip.success')}}</div>
      <div class="alert alert-danger" v-if="sipDelete == 'fail'">{{$t('alert.delete.sip.error')}}</div>

      <div class="alert alert-success" v-if="sipActive == 'ok'">{{$t('alert.sip.active.success')}}</div>
      <div class="alert alert-danger" v-if="sipActive == 'fail'">{{$t('alert.sip.active.error')}}</div>

      <ul class="list-sip">
        <li :class="{'active': item.status == 1 || item.status === 1}" v-for="(item, index) in sipList" :key="index">
          <router-link class="url" :to="{name:'EditSipInfoPage', params: {id: item.id}}">
            {{item.sip_username}}@{{item.sip_domain}}
          </router-link>
          <i @click="showModalActiveSIP(item)" class="fileIco" v-if="item.status == 0 || item.status === 0"></i>
          <font-awesome-icon @click="showModalActiveSIP(item)" :icon="fileCheck" v-if="item.status == 1 || item.status === 1"></font-awesome-icon>
        </li>
      </ul>

        <!--
        <div class="col-xs-6">
          <div class="form-group text-right btn-submit">
            <base-button type="button" class="btn-block btn-default" @click="logout()">{{$t('edit.logout')}}</base-button>
          </div>
        </div>
        -->

        <div class="col-xs-6 fl-right">
          <div class="form-group text-right btn-submit">
            <router-link :to="{name: 'EditSipPage'}">
              <base-button type="button">{{$t('edit.addNewSIP')}}</base-button>
            </router-link>
          </div>
        </div>

        <div class="clearfix"></div>

    </div>
  </div>
</template>

<script>
  import BaseButton from "../components/Button.vue";
  import BaseHeader from "../components/Header.vue";
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
  import file from '@fortawesome/fontawesome-free-regular/faFile';
  import check from '@fortawesome/fontawesome-free-solid/faCheck';
  import i18n from '../languages/i18n';

  import Vue from 'vue'
  import BootstrapVue from 'bootstrap-vue'
  import bModal from 'bootstrap-vue/es/components/modal/modal'
  import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
  import bButton from 'bootstrap-vue/es/components/button/button';
  import bButtonGroup from 'bootstrap-vue/es/components/button-group/button-group';
  import 'bootstrap/dist/css/bootstrap.css'
  import 'bootstrap-vue/dist/bootstrap-vue.css'

  Vue.component('b-modal', bModal);
  Vue.directive('b-modal', bModalDirective);
  Vue.component('b-button', bButton);
  Vue.component('b-button-group', bButtonGroup);

  export default {
    components: {
      BaseHeader,
      BaseButton,
      FontAwesomeIcon,
    },
    name: 'EditPage',
    props: {
      update_profile: [Boolean, Number, String],
      sip_create: [Boolean, Number, String],
      sip_update: [Boolean, Number, String],
      sip_delete: [Boolean, Number, String],
    },
    data() {
      return {
        name: '',
        email: '',
        phone: '',
        cloud_id: '',
        passwordRepeat: '',
        newPassword: '',
        oldPassword: '',
        errorMessage: [],
        user: {},
        message: '',
        sipList: [],
        sipName: '',
        sipItem: {},
        activeSIPError: false,
        updateProfile: this.update_profile ? this.update_profile : '',
        sipCreate: this.sip_create ? this.sip_create : '',
        sipUpdate: this.sip_update ? this.sip_update : '',
        sipDelete: this.sip_delete ? this.sip_delete : '',
        sipActive: '',
      };
    },
    computed: {
      fileIco() {
        return file;
      },
      fileCheck() {
        return check;
      }
    },
    methods: {
      logout() {
        const token = localStorage.getItem('token');
        this.axios.post('/logout?token=' + token).then((response) => {
          if (response.data.status) {
            localStorage.removeItem('token');
            localStorage.removeItem('url');
          }
          this.$router.push({name: 'LoginPage'});
        });
      },
      activeSip() {

        this.updateProfile = '';
        this.sipCreate = '';
        this.sipUpdate = '';
        this.sipDelete = '';

        const token = localStorage.getItem('token');

        if ((this.sipItem.status) <= 0) {
          this.sipList.map((i) => {
            if (i.id === this.sipItem.id) {
              i.status = 1;
            } else {
              i.status = 0;
            }
          });
          this.hideModalActiveSIP();
          this.axios.post('/active/' + this.sipItem.id + '?token=' + token).then((response) => {

              if (response.data.status) {
                //top.window.location.href = response.data.data.url;
                this.sipActive = 'ok';
              } else {
                this.sipActive = 'fail';
              }
              
              /*
              this.axios.get('/sipList?token=' + token).then(response => {
                if (response.data.status) {
                  this.phone = response.data.data.user.phone;
                  this.email = response.data.data.user.email;
                  this.name = response.data.data.user.name;
                  this.sipList = response.data.data.sip;
                  this.sipActive = 'ok';
                } else {
                  localStorage.removeItem('token');
                  localStorage.removeItem('url');
                  this.$router.push({name: 'LoginPage'});
                  this.sipActive = 'fail';
                }
              });
              */

          });
        } else {
          this.sipActive = 'ok';
          this.hideModalActiveSIP();
          // const url = localStorage.getItem('url');
          // if ( (!token) || (token == "") || (token == null) || (token == undefined) || (typeof token == 'undefined') ) {
          if(localStorage.getItem('url')) {
            //top.window.location.href = localStorage.getItem('url');
          } else {
            if(this.phone && this.cloud_id && token) {
              //top.window.location.href = "csc:"+this.phone+":"+token+"@"+this.cloud_id;
            }
          }
        }
      },
      showModalActiveSIP (item) {
        this.sipItem = item;
        this.sipName = item.sip_username + '@' + item.sip_domain;
        this.$refs.myModalRef.show();
      },
      hideModalActiveSIP () {
        this.$refs.myModalRef.hide();
      }
    },
    beforeMount () {
      const token = localStorage.getItem('token');
      if ( (!token) || (token == "") || (token == null) || (token == undefined) || (typeof token == 'undefined') ) {
        localStorage.removeItem('token');
        this.$router.push({name: 'LoginPage'});
      }
      this.axios.get('/sipList?token=' + token).then(response => {
        if (response.data.status && response.data.data.sip.length > 0 && response.data.data.user) {
          this.phone = response.data.data.user.phone;
          this.email = response.data.data.user.email;
          this.name = response.data.data.user.name;
          this.sipList = response.data.data.sip;
          this.cloud_id = response.data.data.cloud_id;
        } else {
          localStorage.removeItem('token');
          localStorage.removeItem('url');
          this.$router.push({name: 'LoginPage'});
        }
      })
    }
  };
</script>
<style scoped="">
</style>



// WEBPACK FOOTER //
// src/pages/EditPage.vue